import React, {Component} from "react";
import {connect} from "react-redux";
import NumberFormat from "react-number-format";
import moment from "moment";
import {axios, Constants, Globals} from "../../../utils";
import {Button, Modal, Select} from "../../../components";
import ModalProducts from "./modal-products";
import CloseIcon from "../../../assets/icons/close-black.png";

const CHANGE_TYPE = {
  NEW_PRODUCT: "NEW_PRODUCT",
  CHANGE_PRICE: "CHANGE_PRICE",
  CHANGE_QUANTITY: "CHANGE_QUANTITY",
  CHANGE_PRICE_QUANTITY: "CHANGE_PRICE_QUANTITY",
};

function parse(value) {
  return parseFloat(parseFloat(value).toFixed(2));
}

function getBillNumber(order) {
  const isFiscalBill = order?.fiscal_bill === Constants.ORDERS.FISCAL_BILL.YES;
  const isFiscalBillFree =
    order?.fiscal_bill_free === Constants.ORDERS.FISCAL_BILL_FREE.YES;

  return isFiscalBill
    ? order?.order_bill?.bill_number
    : isFiscalBillFree
      ? order?.bill_number_format
      : "";
}

class ModalCreateDebit extends Component {
  state = {
    isReadOnly: false,
    visible_products: false,
    showLoteAgotadoModal: false,
    isLoadingWarehouses: false,
    debitedItem: Globals.copy(this.props.debitedItem),
    form: {
      payment_method_id: "",
      date: "",
      bill_number: "",
      comments: "",
    },
    totals: {
      subtotal_usd: 0,
      subtotal_bs: 0,
      paid_usd: 0,
      paid_bs: 0,
      left_usd: 0,
      left_bs: 0,
      total_bs: 0,
      total_usd: 0,
      change_bs: 0,
      change_usd: 0,
      iva_8_bs: 0,
      iva_8_usd: 0,
      iva_16_bs: 0,
      iva_16_usd: 0,
      iva_31_bs: 0,
      iva_31_usd: 0,
      iva_bs: 0,
      iva_usd: 0,
      iva_nd_usd: 0,
      iva_nd_bs: 0,
      igtf_bs: 0,
      igtf_usd: 0,
      additionalIgtf_usd: 0, //IGTF de la ND actual
      additionalIgtf_bs: 0, //IGTF de la ND actual
      discount_bs: 0,
      discount_usd: 0,
      diff_usd: 0,
      diff_bs: 0,
    },
    warehouses: [],
    formatWarehouses: [],
    methods: [],
    onlyRateChanged: false, //Bandera de que solo cambio la tasa de conversion
  };

  componentDidMount() {
    if (this.props?.isReadOnly) this.edit();

    //Seteo el nro de factura SOLO SÍ es formato libre
    if (this.state.debitedItem && !this.props?.isReadOnly) {
      if (this.state.debitedItem.fiscal_bill_free == 1) {
        this.setState((s) => ({
          form: {
            ...s.form,
            bill_number: this.props.debitedItem?.bill_number_format,
          },
        }));
      }
    }

    this.formatOrder();
    this.getExchangeRate();
    this.getWarehouses();
    this.getPaymentMethods();
  }

  toggleLoteAgotadoModal = () => {
    this.setState((s) => ({showLoteAgotadoModal: !s.showLoteAgotadoModal}));
  };

  formatOrder = () => {
    const {exchangeRate} = this.state;
    const isReadOnly = this.props.isReadOnly;

    const formatProduct = (item) => {
      if (!item) return;

      const warehouse_id = Number(
        item.warehouse_id || this.props.user.warehouse_principal,
      );
      let total_quantity = undefined;
      let prices = item.product?.prices;
      const originalPrice = item.price;

      // Busca el producto en los almacenes
      const wh = this.state.warehouses.find((i) => i.id === warehouse_id);
      if (wh) {
        const wp = wh.products.find((i) => i.product_id === item.product_id);
        total_quantity = wp?.total_quantity;
        if (wp?.product) item.product = Globals.copy(wp.product);
      }

      let stock = item.product?.stock;
      const price = item.price ?? item.selected_price ?? item.sale_price;
      prices = item.product?.prices || [];

      if (item.product?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
        const size_color = item.product?.size_colors.find(
          (sc) => sc.size_id === item.size_id && sc.color_id === item.color_id,
        );

        prices = size_color?.prices || [];
        stock = size_color?.stock || 0;
        if (!!size_color?.color)
          item.product.name += `, ${size_color.color.name}`;
        if (!!size_color?.size)
          item.product.name += `, ${size_color.size.name}`;
      }

      prices = [
        {
          value: originalPrice,
          label: `$${Globals.formatMiles(originalPrice, true)}`,
        },
        ...prices.map((i) => ({
          value: i.price,
          label: `$${Globals.formatMiles(i.price, true)}`,
        })),
      ];

      return {
        ...item,
        isPermanent: true,
        originalQuantity: Number(item.quantity),
        originalPrice,
        price,
        price_bs: price * exchangeRate,
        sale_price: price,
        selected_price: price,
        stock,
        total_quantity,
        warehouse_id,
        prices,
      };
    };

    this.setState((s) => {
      let client = s.debitedItem.client;
      let date = moment().format("DD-MM-YYYY");
      let comments = s.form.comments;
      let bill_number = s.debitedItem.bill_number_format;
      let payment_method_id = s.form.payment_method_id;

      if (isReadOnly) {
        client = s.debitedItem.order?.client;
        date = moment(s.debitedItem.created_at).format("DD-MM-YYYY");
        comments = s.debitedItem.motive;
        bill_number = getBillNumber(s.debitedItem.order);
        payment_method_id = s.debitedItem.payments[0]?.method_id;
      }

      return {
        debitedItem: {
          ...s.debitedItem,
          client,
          details: s.debitedItem.details?.map(formatProduct),
        },
        form: {
          ...s.form,
          payment_method_id,
          date,
          comments,
          bill_number,
        },
      };
    });
  };

  formatOutput = () => {
    const {debitedItem, exchangeRate, form, totals, onlyRateChanged} =
      this.state;
    const distinctExchangeRate =
      exchangeRate !== this.props.debitedItem.conversion;
    console.log("totals: ", totals);

    const getChangeType = (item) => {
      if (item._changeType === CHANGE_TYPE.NEW_PRODUCT)
        return CHANGE_TYPE.NEW_PRODUCT;

      const priceChanged = Number(item.price) > item.originalPrice;
      const quantityChanged = Number(item.quantity) > item.originalQuantity;
      if (priceChanged && quantityChanged)
        return CHANGE_TYPE.CHANGE_PRICE_QUANTITY;
      if (priceChanged) return CHANGE_TYPE.CHANGE_PRICE;
      if (quantityChanged) return CHANGE_TYPE.CHANGE_QUANTITY;
      return undefined;
    };

    const formatProduct = (item) => {
      const type = getChangeType(item);
      let quantity = Number(item.quantity) - Number(item.originalQuantity);
      if (quantity === 0) quantity = item.originalQuantity;
      const original_quantity = item.originalQuantity;

      return {
        id: item.product_id,
        type,
        name: item.product.name,
        code: item.product.code,
        exento: item.product.exento,
        price_original:
          type === CHANGE_TYPE.NEW_PRODUCT ? item.price : item.originalPrice,
        price: parse(item.price),
        original_quantity,
        quantity,
        warehouse_id: item.warehouse_id,
        size_id: item.size_id,
        color_id: item.color_id,
        discount_percentage: item.discount_percentage,
      };
    };

    // Obtiene solo los productos que han cambiado
    let allProducts = debitedItem.details.map(formatProduct);
    let products = allProducts.filter((i) => !!i.type);

    // Si ningún producto sufrió cambios, y la tasa de cambio varió, se mandan todos los productos y se les establece el type CHANGE_PRICE
    if (!products.length && distinctExchangeRate) {
      products = allProducts.map((p) => ({
        ...p,
        type: CHANGE_TYPE.CHANGE_PRICE,
      }));
    }

    let amount_usd = totals.diff_usd;
    let amount_bs = totals.diff_bs;
    if (onlyRateChanged) {
      console.log("exchangeRate: ", exchangeRate);
      amount_usd = parse(totals.diff_bs / exchangeRate);
      console.log("amount_usd: ", amount_usd);
    }

    return {
      user_id: this.props.user.id,
      order_id: debitedItem.id,
      igtf: totals.igtf_usd,
      igtf_bs: totals.igtf_bs,
      iva: totals.iva_nd_usd,
      iva_bs: totals.iva_nd_bs,
      total: totals.total_usd,
      bill_number: form.bill_number,
      comments: form.comments,
      products,
      payment_methods: [
        {
          method_id: form.payment_method_id,
          amount: amount_usd,
          amount_bs: amount_bs,
        },
      ],
      discount_percentage: debitedItem.discount_percentage,
      onlyRateChanged,
    };
  };

  edit = () => {
    this.setState({
      isReadOnly: true,
      form: {
        bill_number: this.props.debitedItem?.order_bill?.bill_number,
        comments: this.props.debitedItem?.comments,
      },
    });
  };

  getExchangeRate = async () => {
    try {
      if (this.props.isReadOnly) {
        await this.setState({
          exchangeRate: parseFloat(this.state.debitedItem.conversion) || 0,
        });
        this.setTotals();
      } else {
        const filter = {user_id: this.props.user.id};

        const res = await axios.post("admin/conversions/getbcv", filter);
        if (!res.data?.conversion)
          throw Error("Debe establecer una tasa de cambio para continuar");

        await this.setState({
          exchangeRate: parseFloat(res.data?.conversion) || 0,
        });
        this.setTotals();
      }
    } catch (error) {
      Globals.showError(error?.message);
      console.log("NewRequest -> getExchangeRate -> catch:", error);
    }
  };

  getPaymentMethods = async () => {
    try {
      const filter = {
        user_id: this.props.user.id,
      };

      const res = await axios.post("web/admin/orders/methods", filter);
      if (!res.data?.methods)
        throw Error("No se encontraron los métodos de pago");

      this.setState({methods: res.data?.methods});
    } catch (error) {
      Globals.showError(error?.message);
      console.log("Return -> getPaymentMethods -> catch:", error);
    }
  };

  getWarehouses = async () => {
    try {
      this.setState({isLoadingWarehouses: true});

      const data = {
        web: true,
        user_id: this.props.user.id,
        is_select: true,
        //Comentado para prod
        warehouse_id:
          this.props.user.level_id == Constants.ROLE_ADMIN
            ? null
            : this.props.user.warehouse_id,
        // warehouse_id: this.props.user.warehouse_principal,
        unique_by_size_color: true, //para que traiga solo una talla/color en caso de ser por talla/color
      };

      const res = await axios.post("web/admin/warehouses", data);
      if (res.data?.warehouses) {
        const formatWarehouses = res.data.warehouses.map((Item) => ({
          value: Item.id,
          label: Item.name,
        }));

        const mainIdx = formatWarehouses.findIndex(
          (x) => x.value === this.props.user.warehouse_principal,
        );
        if (mainIdx >= 0) {
          const main = formatWarehouses[mainIdx];
          formatWarehouses.splice(mainIdx, 1);
          formatWarehouses.unshift(main);
        }

        await this.setState({
          warehouses: res.data.warehouses,
          formatWarehouses: formatWarehouses,
        });
        this.formatOrder();
      }
    } catch (error) {
      Globals.showError();
      console.log("NewRequest -> getWarehouses -> catch: ", error);
    }
    this.setState({isLoadingWarehouses: false});
  };

  toggleProductsModal = () => {
    if (!this.state.exchangeRate)
      return Globals.showError(
        "Debe establecer una tasa de cambio para continuar",
      );
    this.setState((state) => ({visible_products: !state.visible_products}));
  };

  addProduct = async (product, warehouse_id) => {
    this.setState((state) => ({
      form: {
        ...state.form,
        warehouse_id: warehouse_id,
      },
    }));

    let productIndex;
    let products = Globals.copy(this.state.debitedItem.details);

    productIndex =
      product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR
        ? products.findIndex(
            (p) =>
              p.product_id === product.id &&
              p.size_id === product.size_id &&
              p.color_id === product.color_id,
          )
        : products.findIndex((p) => p.product_id === product.id);

    const subtotal = parseFloat(product.price) * parseFloat(product.quantity);
    const discount = (subtotal * (product.discount || 0)) / 100;
    const total = parse(subtotal - discount);

    const item = {
      product,
      product_id: product.id,
      price: product.price,
      price_bs: product.price * this.state.exchangeRate,
      price_original: product.price,
      originalPrice: product.price,
      originalQuantity: product.quantity,
      quantity: product.quantity,
      color_id: product.color_id,
      size_id: product.size_id,
      warehouse_id,
      discount_percentage: product.discount,
      discount,
      subtotal,
      total,
      _changeType: CHANGE_TYPE.NEW_PRODUCT,
    };

    if (productIndex >= 0) {
      const newQuantity =
        parseFloat(products[productIndex].quantity) + parseFloat(item.quantity);
      if (newQuantity > products[productIndex].stock)
        return Globals.showError(
          `No hay suficiente stock (${products[productIndex].stock} disponibles)`,
        );

      products[productIndex].quantity = newQuantity;
    } else {
      products = [...products, item];
    }

    await this.setState((s) => ({
      debitedItem: {...s.debitedItem, details: products},
    }));
    await this.setTotals();
  };

  removeProduct = async (index) => {
    let products = this.state.debitedItem.details.filter(
      (_, idx) => idx !== index,
    );
    await this.setState((s) => ({
      debitedItem: {...s.debitedItem, details: products},
    }));
    await this.setTotals();
  };

  oneMoreProduct = async (index) => {
    const products = Globals.copy(this.state.debitedItem.details);
    const product = products[index];
    let qty = Number(products[index].quantity);
    let newQuantity = qty + 1;
    if (product.product.decimal_stock == Constants.DECIMAL_STOCK.YES) {
      newQuantity = parseFloat(qty + 1).toFixed(2);
    }

    const stockToValidate =
      products[index].product.total_quantity !== undefined
        ? products[index].product.total_quantity
        : products[index].product.stock;

    if (Number(newQuantity) > Number(stockToValidate))
      return Globals.showError(
        `No hay suficiente stock de ${products[index].product.name}`,
      );

    products[index].quantity = newQuantity;
    await this.setState((s) => ({
      debitedItem: {...s.debitedItem, details: products},
    }));
    this.setTotals();
  };

  oneLessProduct = async (index) => {
    const products = Globals.copy(this.state.debitedItem.details);
    const product = products[index];
    let qty = Number(products[index].quantity);
    let newQuantity = qty - 1;
    if (product.decimal_stock == Constants.DECIMAL_STOCK.YES) {
      newQuantity = parseFloat(qty - 1).toFixed(2);
    }

    if (newQuantity < 1) return;

    const stockToValidate =
      products[index].product.total_quantity !== undefined
        ? products[index].product.total_quantity
        : products[index].product.stock;

    if (Number(newQuantity) > Number(stockToValidate)) {
      newQuantity = stockToValidate;
      Globals.showError(
        `No hay suficiente stock de ${products[index].product.name}`,
      );
    }

    products[index].quantity = newQuantity;
    await this.setState((s) => ({
      debitedItem: {...s.debitedItem, details: products},
    }));
    this.setTotals();
  };

  changeManual = async (index, quantity) => {
    const products = Globals.copy(this.state.debitedItem.details);
    let newQuantity = quantity;

    if (products[index].product?.decimal_stock === Constants.DECIMAL_STOCK.NO) {
      newQuantity = newQuantity === "" ? newQuantity : parseInt(newQuantity);
    } else {
      newQuantity = newQuantity.replace(/,/g, ".");
    }

    products[index].quantity = newQuantity;
    products[index].showPrices = false;
    await this.setState((s) => ({
      debitedItem: {...s.debitedItem, details: products},
    }));
    this.setTotals();
  };

  change = async (value, target) => {
    await this.setState((s) => ({form: {...s.form, [target]: value}}));
    if (target === "payment_method_id") this.setTotals();
  };

  changeItem = async (value, target, index) => {
    const details = Globals.copy(this.state.debitedItem.details);
    details[index][target] = value;
    const isNew = details[index]._changeType === CHANGE_TYPE.NEW_PRODUCT;

    if (target !== "showPrices") details[index].showPrices = false;
    if (target === "price_bs")
      details[index].price = value / this.state.exchangeRate;
    if (target === "price")
      details[index].price_bs = value * this.state.exchangeRate;
    if (target === "quantity" && isNew)
      details[index].originalQuantity = parseFloat(value);

    await this.setState((s) => ({
      debitedItem: {...s.debitedItem, details},
    }));
    this.setTotals();
  };

  convert = (value) => {
    return value * (this.state.exchangeRate || 1);
  };

  setTotalsOLD = async () => {
    if (this.props.isReadOnly) return;

    const {debitedItem, form} = this.state;
    const exchangeRate = this.state.exchangeRate || 1;
    const products = [...debitedItem.details];
    const generalDiscountRate = (debitedItem.discount_percentage || 0) / 100;

    let baseWithoutGeneral_usd = 0;
    let ivaND_usd = 0;
    let igtfND_usd = 0;

    const ivaByRate_usd = {
      [Constants.PRODUCT_IVA.OCHO]: 0,
      [Constants.PRODUCT_IVA.DIECISEIZ]: 0,
      [Constants.PRODUCT_IVA.TREINTAIUNO]: 0,
    };

    const methodId = form.payment_method_id
      ? Number(form.payment_method_id)
      : null;
    const isPaymentInUSD =
      methodId !== null && !Constants.LOCAL_CURRENCIES.includes(methodId);

    const originalRate = this.props.debitedItem?.conversion || 1;
    const distinctExchangeRate = exchangeRate !== originalRate;

    const onlyRateChanged =
      distinctExchangeRate &&
      products.every(
        (p) =>
          Number(p.price) === Number(p.originalPrice) &&
          Number(p.quantity) === Number(p.originalQuantity),
      );

    products.forEach((prod) => {
      const qty =
        prod.decimal_stock === Constants.DECIMAL_STOCK.YES
          ? Number(prod.quantity)
          : parseInt(prod.quantity, 10);

      const price =
        prod.price != null ? Number(prod.price) : Number(prod.sale_price);
      const lineGross = qty * price;
      const discPct = prod.discount_percentage ?? prod.discount ?? 0;
      const indivDiscount = parse((lineGross * discPct) / 100);
      const baseAfterIndiv_usd = parse(lineGross - indivDiscount);
      prod.baseAfterIndiv_usd = baseAfterIndiv_usd;
      prod.baseAfterIndiv_bs = parse(baseAfterIndiv_usd * exchangeRate);

      baseWithoutGeneral_usd += baseAfterIndiv_usd;

      const originalQty = Number(prod.originalQuantity ?? 0);
      const newQty = Number(prod.quantity);
      const addedQty = newQty - originalQty;
      const priceNum = price;
      const isNewOrIncreased =
        prod.originalQuantity === undefined ||
        addedQty > 0 ||
        priceNum !== Number(prod.originalPrice);
      const qtyForND = prod.originalQuantity === undefined ? newQty : addedQty;

      const ivaPct = prod.product?.iva_porcentage ?? prod.iva_porcentage ?? 0;
      const exento = prod.product?.exento ?? prod.exento;

      if (
        isNewOrIncreased &&
        qtyForND > 0 &&
        exento === Constants.PRODUCT_EXENTO.NO
      ) {
        const grossND = qtyForND * priceNum;
        const indivDiscountND = parse((grossND * discPct) / 100);
        const baseAfterIndivND = parse(grossND - indivDiscountND);
        const baseAfterGeneralND = parse(
          baseAfterIndivND * (1 - generalDiscountRate),
        );

        const ivaND = parse((baseAfterGeneralND * ivaPct) / 100);
        ivaND_usd += ivaND;

        if (isPaymentInUSD) {
          const igtfND = parse(
            (baseAfterGeneralND * Constants.TAXES.IGTF) / 100,
          );
          igtfND_usd += igtfND;
        }
      }
    });

    const generalDiscount_usd = parse(
      baseWithoutGeneral_usd * generalDiscountRate,
    );
    const netBase_usd = parse(baseWithoutGeneral_usd - generalDiscount_usd);

    let totalIva_usd = 0;
    ivaByRate_usd[Constants.PRODUCT_IVA.OCHO] = 0;
    ivaByRate_usd[Constants.PRODUCT_IVA.DIECISEIZ] = 0;
    ivaByRate_usd[Constants.PRODUCT_IVA.TREINTAIUNO] = 0;

    products.forEach((prod) => {
      const proportion =
        baseWithoutGeneral_usd > 0
          ? prod.baseAfterIndiv_usd / baseWithoutGeneral_usd
          : 0;
      const lineNetBase = parse(netBase_usd * proportion);
      const ivaPct = prod.product?.iva_porcentage ?? prod.iva_porcentage ?? 0;
      const exento = prod.product?.exento ?? prod.exento;

      if (exento === Constants.PRODUCT_EXENTO.NO) {
        const ivaLine = parse((lineNetBase * ivaPct) / 100);
        prod.iva_usd = ivaLine;
        totalIva_usd += ivaLine;
        ivaByRate_usd[prod.product?.iva ?? prod.iva] += ivaLine;
        prod.subtotal = parse(lineNetBase + ivaLine);
      } else {
        prod.iva_usd = 0;
        prod.subtotal = lineNetBase;
      }
    });

    let total_usd = parse(netBase_usd + totalIva_usd);

    const paid_usd = parse(
      debitedItem.payment_methods.reduce((sum, m) => sum + Number(m.amount), 0),
    );
    let change_usd = 0;
    let left_usd = parse(total_usd - paid_usd);
    if (left_usd < 0) {
      change_usd = parse(-left_usd);
      left_usd = 0;
    }

    const netBase_bs = parse(netBase_usd * exchangeRate);
    const iva_bs = parse(totalIva_usd * exchangeRate);
    let ivaND_bs = parse(ivaND_usd * exchangeRate);
    const paid_bs = parse(
      debitedItem.payment_methods.reduce(
        (sum, m) => sum + Number(m.amount_bs),
        0,
      ),
    );
    let change_bs = parse(change_usd * exchangeRate);
    let total_bs = parse(total_usd * exchangeRate);
    let left_bs = parse(total_bs - paid_bs);
    if (left_bs < 0) {
      change_bs = parse(-left_bs);
      left_bs = 0;
    }

    const totalOriginal_usd =
      parse(debitedItem.total || 0) - parse(debitedItem.igtf || 0);
    let diff_usd = parse(total_usd - totalOriginal_usd);
    let igtf_usd = igtfND_usd;
    let igtf_bs = parse(igtfND_usd * exchangeRate);
    let igtf_total_usd = parse(igtf_usd + parse(debitedItem.igtf || 0));
    let igtf_total_bs = parse(igtf_total_usd * exchangeRate);

    // Caso especial: solo cambió la tasa
    let diff_bs = 0;
    if (onlyRateChanged && parse(diff_usd) === 0) {
      //ivaND_usd = parse(debitedItem.iva || 0);
      ivaND_bs = parse(debitedItem.iva * exchangeRate);
      //igtf_usd = parse(debitedItem.igtf || 0);
      igtf_bs = parse(debitedItem.igtf * exchangeRate);
      //igtf_total_usd = parse(igtf_usd + parse(debitedItem.igtf || 0));
      //igtf_total_bs = parse(igtf_total_usd * exchangeRate);
      diff_bs = parse(
        (debitedItem.total - (debitedItem.igtf || 0)) *
          (exchangeRate - originalRate),
      );
      diff_usd = parse(diff_bs / exchangeRate);
    } else {
      diff_usd = parse(diff_usd + igtf_usd);
      diff_bs = parse(diff_usd * exchangeRate);
    }

    total_usd = parse(total_usd + igtf_total_usd);
    total_bs = parse(total_usd * exchangeRate);
    left_usd = parse(total_usd - paid_usd);
    left_bs = parse(total_bs - paid_bs);
    if (left_usd < 0) {
      change_usd = parse(-left_usd);
      left_usd = 0;
    }
    if (left_bs < 0) {
      change_bs = parse(-left_bs);
      left_bs = 0;
    }

    await this.setState((s) => ({
      debitedItem: {
        ...s.debitedItem,
        details: products,
      },
      totals: {
        subtotal_without_disc_usd: parse(baseWithoutGeneral_usd),
        discount_usd: generalDiscount_usd,
        netBase_usd,
        iva_usd: totalIva_usd,
        iva_nd_usd: ivaND_usd,
        iva_8_usd: ivaByRate_usd[Constants.PRODUCT_IVA.OCHO],
        iva_16_usd: ivaByRate_usd[Constants.PRODUCT_IVA.DIECISEIZ],
        iva_31_usd: ivaByRate_usd[Constants.PRODUCT_IVA.TREINTAIUNO],
        igtf_usd,
        igtf_total_usd,
        total_usd,
        paid_usd,
        change_usd,
        left_usd,

        subtotal_without_disc_bs: parse(baseWithoutGeneral_usd * exchangeRate),
        discount_bs: parse(generalDiscount_usd * exchangeRate),
        netBase_bs,
        iva_bs,
        iva_nd_bs: ivaND_bs,
        iva_8_bs: parse(
          ivaByRate_usd[Constants.PRODUCT_IVA.OCHO] * exchangeRate,
        ),
        iva_16_bs: parse(
          ivaByRate_usd[Constants.PRODUCT_IVA.DIECISEIZ] * exchangeRate,
        ),
        iva_31_bs: parse(
          ivaByRate_usd[Constants.PRODUCT_IVA.TREINTAIUNO] * exchangeRate,
        ),
        igtf_bs,
        igtf_total_bs,
        total_bs,
        paid_bs,
        change_bs,
        left_bs,

        diff_usd,
        diff_bs,
      },
      onlyRateChanged,
    }));
  };

  setTotals = async () => {
    if (this.props.isReadOnly) return;

    const {debitedItem, form} = this.state;
    const exchangeRate = this.state.exchangeRate || 1;
    const products = [...debitedItem.details];
    const generalDiscountRate = (debitedItem.discount_percentage || 0) / 100;

    let baseWithoutGeneral_usd = 0;
    let ivaND_usd = 0;
    let igtfND_usd = 0;

    const ivaByRate_usd = {
      [Constants.PRODUCT_IVA.OCHO]: 0,
      [Constants.PRODUCT_IVA.DIECISEIZ]: 0,
      [Constants.PRODUCT_IVA.TREINTAIUNO]: 0,
    };

    const methodId = form.payment_method_id
      ? Number(form.payment_method_id)
      : null;
    const isPaymentInUSD =
      methodId !== null && !Constants.LOCAL_CURRENCIES.includes(methodId);

    const originalRate = this.props.debitedItem?.conversion || 1;
    const distinctExchangeRate = exchangeRate !== originalRate;

    const onlyRateChanged =
      distinctExchangeRate &&
      products.every(
        (p) =>
          Number(p.price) === Number(p.originalPrice) &&
          Number(p.quantity) === Number(p.originalQuantity),
      );

    // Recorre productos y calcula base, IVA, IGTF solo cuando hay cambios en productos
    products.forEach((prod) => {
      const qty =
        prod.decimal_stock === Constants.DECIMAL_STOCK.YES
          ? Number(prod.quantity)
          : parseInt(prod.quantity, 10);

      const price =
        prod.price != null ? Number(prod.price) : Number(prod.sale_price);
      const lineGross = qty * price;
      const discPct = prod.discount_percentage ?? prod.discount ?? 0;
      const indivDiscount = parse((lineGross * discPct) / 100);
      const baseAfterIndiv_usd = parse(lineGross - indivDiscount);
      prod.baseAfterIndiv_usd = baseAfterIndiv_usd;
      prod.baseAfterIndiv_bs = parse(baseAfterIndiv_usd * exchangeRate);

      baseWithoutGeneral_usd += baseAfterIndiv_usd;

      const originalQty = Number(prod.originalQuantity ?? 0);
      const newQty = Number(prod.quantity);
      const addedQty = newQty - originalQty;
      const priceNum = price;

      // NUEVA LÓGICA:
      const isNewProduct =
        prod.originalQuantity === undefined ||
        prod._changeType === CHANGE_TYPE.NEW_PRODUCT;
      const isQtyIncreased = addedQty > 0;
      const isPriceIncreased = priceNum > Number(prod.originalPrice);

      let qtyForND = 0;
      if (isNewProduct) {
        qtyForND = newQty;
      } else if (isQtyIncreased) {
        qtyForND = addedQty;
      } else if (isPriceIncreased) {
        qtyForND = originalQty;
      }

      const ivaPct = prod.product?.iva_porcentage ?? prod.iva_porcentage ?? 0;
      const exento = prod.product?.exento ?? prod.exento;

      // SOLO calcular IVA e IGTF por producto si NO es solo cambio de tasa
      if (
        //!onlyRateChanged &&
        (isNewProduct || isQtyIncreased || isPriceIncreased) &&
        qtyForND > 0
      ) {
        const grossND = qtyForND * priceNum;
        const indivDiscountND = parse((grossND * discPct) / 100);
        const baseAfterIndivND = parse(grossND - indivDiscountND);
        const baseAfterGeneralND = parse(
          baseAfterIndivND * (1 - generalDiscountRate),
        );

        if (exento === Constants.PRODUCT_EXENTO.NO) {
          const ivaND = parse((baseAfterGeneralND * ivaPct) / 100);
          ivaND_usd += ivaND;
          console.log(
            `→ IVA ND de ${prod.product?.code} (cantidad ND: ${qtyForND}, base: ${baseAfterGeneralND}): $${ivaND}`,
          );
        }

        if (isPaymentInUSD) {
          const igtfND = parse(
            (baseAfterGeneralND * Constants.TAXES.IGTF) / 100,
          );
          igtfND_usd += igtfND;
          console.log(
            `→ IGTF ND de ${prod.product?.code} (base: ${baseAfterGeneralND}): $${igtfND}`,
          );
        }
      }

      // *** NO CALCULES IGTF ND POR SOLO CAMBIO DE TASA EN EL FOR ***
    });

    const generalDiscount_usd = parse(
      baseWithoutGeneral_usd * generalDiscountRate,
    );
    const netBase_usd = parse(baseWithoutGeneral_usd - generalDiscount_usd);

    let totalIva_usd = 0;
    ivaByRate_usd[Constants.PRODUCT_IVA.OCHO] = 0;
    ivaByRate_usd[Constants.PRODUCT_IVA.DIECISEIZ] = 0;
    ivaByRate_usd[Constants.PRODUCT_IVA.TREINTAIUNO] = 0;

    products.forEach((prod) => {
      const proportion =
        baseWithoutGeneral_usd > 0
          ? prod.baseAfterIndiv_usd / baseWithoutGeneral_usd
          : 0;
      const lineNetBase = parse(netBase_usd * proportion);
      const ivaPct = prod.product?.iva_porcentage ?? prod.iva_porcentage ?? 0;
      const exento = prod.product?.exento ?? prod.exento;

      if (exento === Constants.PRODUCT_EXENTO.NO) {
        const ivaLine = parse((lineNetBase * ivaPct) / 100);
        prod.iva_usd = ivaLine;
        totalIva_usd += ivaLine;
        ivaByRate_usd[prod.product?.iva ?? prod.iva] += ivaLine;
        prod.subtotal = parse(lineNetBase + ivaLine);
      } else {
        prod.iva_usd = 0;
        prod.subtotal = lineNetBase;
      }
    });

    let total_usd = parse(netBase_usd + totalIva_usd);

    const paid_usd = parse(
      debitedItem.payment_methods.reduce((sum, m) => sum + Number(m.amount), 0),
    );
    let change_usd = 0;
    let left_usd = parse(total_usd - paid_usd);
    if (left_usd < 0) {
      change_usd = parse(-left_usd);
      left_usd = 0;
    }

    const netBase_bs = parse(netBase_usd * exchangeRate);
    const iva_bs = parse(totalIva_usd * exchangeRate);
    let ivaND_bs = parse(ivaND_usd * exchangeRate);
    const paid_bs = parse(
      debitedItem.payment_methods.reduce(
        (sum, m) => sum + Number(m.amount_bs),
        0,
      ),
    );
    let change_bs = parse(change_usd * exchangeRate);
    let total_bs = parse(total_usd * exchangeRate);
    let left_bs = parse(total_bs - paid_bs);
    if (left_bs < 0) {
      change_bs = parse(-left_bs);
      left_bs = 0;
    }

    const totalOriginal_usd =
      parse(debitedItem.total || 0) - parse(debitedItem.igtf || 0);
    let diff_usd = parse(total_usd - totalOriginal_usd);
    let igtf_usd = igtfND_usd;
    let igtf_bs = parse(igtf_usd * exchangeRate);
    let igtf_total_usd = parse(igtf_usd + parse(debitedItem.igtf || 0));
    let igtf_total_bs = parse(igtf_total_usd * exchangeRate);

    // === IGTF ND SOLO CAMBIO DE TASA (GLOBAL) ===
    let diff_bs = 0;
    let igtfNDOnlyRate_usd = 0;
    let igtfNDOnlyRate_bs = 0;

    // Caso especial: solo cambió la tasa
    if (onlyRateChanged && parse(diff_usd) === 0) {
      /*
      ivaND_bs = parse(debitedItem.iva * exchangeRate);
      igtf_bs = parse(debitedItem.igtf * exchangeRate) + igtfNDOnlyRate_bs;
      diff_bs = parse((debitedItem.total - (debitedItem.igtf || 0)) * (exchangeRate - originalRate));
      diff_usd = parse(diff_bs / exchangeRate);
      console.log('→ Solo cambió la tasa. Recalculando en Bs a la tasa actual. diff_bs:', diff_bs);
      console.log('→ Solo cambió la tasa. Recalculando en Bs a la tasa actual. diff_usd:', diff_usd);

      //Calculo de IGTF
      if (debitedItem.igtf === 0 && isPaymentInUSD) {
        igtfNDOnlyRate_usd = parseFloat((diff_usd * Constants.TAXES.IGTF / 100).toFixed(2));
        console.log('->igtfNDOnlyRate_usd: ', igtfNDOnlyRate_usd)
        igtfNDOnlyRate_bs = parseFloat((igtfNDOnlyRate_usd * exchangeRate).toFixed(2));
        console.log(
          `→ IGTF ND por solo cambio de tasa y pago en USD: $${igtfNDOnlyRate_usd} (diff_usd: $${diff_usd})`
        );

        // seteo los IGTF otra vez
        igtf_usd += igtfNDOnlyRate_usd;
        console.log('→IGTF ND (USD):', igtf_usd);
        igtf_bs = parse(igtf_usd * exchangeRate);
        console.log('→IGTF ND (BS):', igtf_bs);
        igtf_total_usd += igtf_usd;
        igtf_total_bs = parse(igtf_total_usd * exchangeRate);
        console.log('→IGTF TOTAL (USD):', igtf_total_usd);
        console.log('→IGTF TOTAL (BS):', igtf_total_bs);
      } else {
        console.log('→ No hay pago USD actual en la ND (solo cambio de tasa o diff_usd <= 0)');
      }
      */
    } else {
      diff_usd = parse(diff_usd + igtf_usd);
      diff_bs = parse(diff_usd * exchangeRate);
    }

    total_usd = parse(total_usd + igtf_total_usd);
    total_bs = parse(total_usd * exchangeRate);
    left_usd = parse(total_usd - paid_usd);
    left_bs = parse(total_bs - paid_bs);
    if (left_usd < 0) {
      change_usd = parse(-left_usd);
      left_usd = 0;
    }
    if (left_bs < 0) {
      change_bs = parse(-left_bs);
      left_bs = 0;
    }

    console.log("→ TOTAL FINAL (USD):", total_usd);
    console.log("→ TOTAL FINAL (Bs):", total_bs);

    await this.setState((s) => ({
      debitedItem: {
        ...s.debitedItem,
        details: products,
      },
      totals: {
        subtotal_without_disc_usd: parse(baseWithoutGeneral_usd),
        discount_usd: generalDiscount_usd,
        netBase_usd,
        iva_usd: totalIva_usd,
        iva_nd_usd: ivaND_usd,
        iva_8_usd: ivaByRate_usd[Constants.PRODUCT_IVA.OCHO],
        iva_16_usd: ivaByRate_usd[Constants.PRODUCT_IVA.DIECISEIZ],
        iva_31_usd: ivaByRate_usd[Constants.PRODUCT_IVA.TREINTAIUNO],
        igtf_usd,
        igtf_total_usd,
        total_usd,
        paid_usd,
        change_usd,
        left_usd,

        subtotal_without_disc_bs: parse(baseWithoutGeneral_usd * exchangeRate),
        discount_bs: parse(generalDiscount_usd * exchangeRate),
        netBase_bs,
        iva_bs,
        iva_nd_bs: ivaND_bs,
        iva_8_bs: parse(
          ivaByRate_usd[Constants.PRODUCT_IVA.OCHO] * exchangeRate,
        ),
        iva_16_bs: parse(
          ivaByRate_usd[Constants.PRODUCT_IVA.DIECISEIZ] * exchangeRate,
        ),
        iva_31_bs: parse(
          ivaByRate_usd[Constants.PRODUCT_IVA.TREINTAIUNO] * exchangeRate,
        ),
        igtf_bs,
        igtf_total_bs,
        total_bs,
        paid_bs,
        change_bs,
        left_bs,

        diff_usd,
        diff_bs,
      },
      onlyRateChanged,
    }));
  };

  isValidForm = () => {
    const onError = (msg) => {
      Globals.showError(msg);
      return false;
    };

    const {debitedItem, form, totals} = this.state;

    if (!form.comments)
      return onError("Debe indicar el motivo de la nota de débito");
    if (!form.bill_number)
      return onError("Debe indicar el número de la factura");
    if (!form.payment_method_id)
      return onError("Debe indicar el método de pago");

    let item = debitedItem.details.find(
      (i) => isNaN(Number(i.quantity)) || i.quantity === "",
    );
    if (item)
      return onError(
        `Debe ingresar la cantidad del producto (${item.product.name})`,
      );

    item = debitedItem.details.find(
      (i) => i.isPermanent && Number(i.quantity) < i.originalQuantity,
    );
    if (item)
      return onError(
        `La cantidad no puede ser menor a la cantidad original (${item.product.name})`,
      );

    item = debitedItem.details.find((i) => Number(i.quantity) <= 0);
    if (item)
      return onError(`La cantidad debe ser mayor a 0 (${item.product.name})`);

    item = debitedItem.details.find(
      (i) => isNaN(Number(i.price)) || i.price === "",
    );
    if (item) return onError(`Debe ingresar el precio (${item.product.name})`);

    item = debitedItem.details.find((i) => Number(i.price) <= 0);
    if (item)
      return onError(`El precio debe ser mayor a 0 (${item.product.name})`);

    item = debitedItem.details.find(
      (i) => parse(i.price) < parse(i.originalPrice),
    );
    if (item)
      return onError(
        `El precio actual no puede ser menor al precio original (${item.product.name})`,
      );

    if (totals.diff_usd <= 0)
      return onError(`El aumento total debe ser mayor a 0`);

    return true;
  };

  submit = async () => {
    if (!this.isValidForm()) return;
    Globals.setLoading();

    const data = this.formatOutput();
    console.log("data: ", data);

    try {
      const res = await axios.post("admin/orders/fiscal-bill/debitnote", data);

      if (res.data?.lote_agotado || res.data?.result === false) {
        if (
          res.data?.lote_agotado ||
          res.data?.error?.includes("Lote de Formas Libres agotado")
        ) {
          this.setState({showLoteAgotadoModal: true});
        } else if (res.data?.error) {
          Globals.showError(res.data.error);
        }
      }
      //Caso impresora fiscal
      else if (res.data.result) {
        Globals.showSuccess("Nota de débito creada con éxito");
        this.props.onSuccess();
      }
      //Caso formato libre
      else if (res.data?.url) {
        Globals.showSuccess("Nota de débito creada con éxito");
        const link = document.createElement("a");
        link.href = res.data?.url;
        link.target = "_blank";
        link.click();
        this.props.onSuccess();
      }
    } catch (error) {
      const errorData = error?.response?.data;
      if (
        errorData?.lote_agotado ||
        errorData?.error?.includes("Lote de Formas Libres agotado")
      ) {
        this.setState({showLoteAgotadoModal: true});
      } else {
        Globals.showError(errorData?.error ?? "Ocurrió un error inesperado");
      }
    }

    Globals.quitLoading();
  };

  render() {
    const {
      form,
      isReadOnly,
      isLoadingWarehouses,
      debitedItem,
      totals,
      visible_products,
      showLoteAgotadoModal,
    } = this.state;

    return (
      <div id="modal-create-debit">
        {showLoteAgotadoModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 99999,
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                width: "460px",
                maxWidth: "90%",
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "#fce8e6",
                  padding: "24px 20px 16px 20px",
                  borderBottom: "1px solid #f5c6cb",
                }}
              >
                <div
                  style={{
                    fontSize: "44px",
                    color: "#d93025",
                    lineHeight: "1",
                    marginBottom: "8px",
                  }}
                >
                  ⚠️
                </div>
                <h2
                  style={{
                    color: "#d93025",
                    margin: 0,
                    fontSize: "26px",
                    fontWeight: "bold",
                  }}
                >
                  ¡Advertencia!
                </h2>
              </div>
              <div style={{padding: "24px 30px"}}>
                <p
                  style={{
                    color: "#3c4043",
                    fontSize: "15px",
                    lineHeight: "1.5",
                    margin: 0,
                  }}
                >
                  Lote de Formas Libres agotado. Por favor, configure un nuevo
                  lote autorizado por la imprenta para continuar
                </p>
              </div>
              <div
                style={{
                  padding: "0 20px 20px 20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={this.toggleLoteAgotadoModal}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#000",
                    fontWeight: "bold",
                    fontSize: "16px",
                    cursor: "pointer",
                    padding: "8px 24px",
                  }}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        <Modal
          className="modal-report-sale-products"
          title="Productos"
          onClose={this.toggleProductsModal}
          visible={visible_products}
          size="lg"
        >
          <ModalProducts
            onSelectProduct={this.addProduct}
            onClose={this.toggleProductsModal}
            warehouses={this.state.warehouses}
            formatWarehouses={this.state.formatWarehouses}
          />
        </Modal>

        <div className="section">
          <p>Datos de factura y cliente</p>
        </div>

        <div className="modal-top">
          <div>
            <p>Cliente: {debitedItem?.client?.name}</p>
            {!!debitedItem?.client?.phone && (
              <p>Teléfono: {debitedItem?.client?.phone}</p>
            )}
            {!!debitedItem?.client?.email && (
              <p>Correo: {debitedItem?.client?.email}</p>
            )}
            {!!debitedItem?.client?.address && (
              <p>Dirección: {debitedItem?.client?.address}</p>
            )}
            <p className="conversion">
              Tasa de cambio: Bs.{" "}
              {Globals.newFormatMiles(this.state.exchangeRate || 0, 4)}
            </p>
          </div>
          <div>
            <p className="bill-number">
              N° de factura:{" "}
              {debitedItem?.fiscal_bill === Constants.ORDERS.FISCAL_BILL.YES
                ? debitedItem?.order_bill?.bill_number || ""
                : debitedItem?.fiscal_bill_free ===
                    Constants.ORDERS.FISCAL_BILL.YES
                  ? debitedItem?.bill_number_format || ""
                  : ""}
            </p>
            <p>
              Fecha de emisión:{" "}
              {moment(
                isReadOnly
                  ? debitedItem?.order?.created_at
                  : debitedItem?.created_at,
              ).format("DD-MM-YYYY")}
            </p>
            {/* <p>Forma de pago: { debitedItem?.payment_methods_text }</p> */}
          </div>
        </div>

        <section className="table-wrapper">
          <div className="table-header">
            <Button
              onClick={() => this.toggleProductsModal()}
              disabled={isLoadingWarehouses || isReadOnly}
            >
              <div className="loader-wrapper">
                {isLoadingWarehouses && <div class="loader" />}
                <span>AGREGAR PRODUCTO</span>
              </div>
            </Button>
          </div>
        </section>

        <table border={1} style={{width: "98%"}}>
          <thead>
            <tr>
              <td>Código</td>
              <td>Descripción del producto</td>
              <td align="right">Precio del producto (Bs)</td>
              <td>Cantidad vendida</td>
              <td align="right">Neto</td>
            </tr>
          </thead>
          <tbody>
            {debitedItem?.details?.map((item, index) => (
              <tr key={index}>
                <td>{item?.product?.code}</td>
                <td>{item?.product?.name}</td>
                <td align="right">
                  {item.showPrices ? (
                    <select
                      value={item.price}
                      options={item.prices}
                      onChange={(e) =>
                        this.changeItem(e.target.value, "price", index)
                      }
                    >
                      {item.prices.map((i, idx) => (
                        <option key={`price-${index}-${idx}`} value={i.value}>
                          {i.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <NumberFormat
                      style={{width: "8rem"}}
                      value={
                        isReadOnly ? this.convert(item.price) : item.price_bs
                      }
                      allowNegative={false}
                      decimalScale={2}
                      onValueChange={async (v) =>
                        this.changeItem(v.value, "price_bs", index)
                      }
                      disabled={isReadOnly}
                    />
                  )}

                  {item.isPermanent && !isReadOnly && (
                    <>
                      <span className="ml-2" />
                      <Button
                        small
                        onClick={() =>
                          this.changeItem(!item.showPrices, "showPrices", index)
                        }
                        title="Precios"
                      >
                        {item.showPrices ? (
                          <i className="fa fa-times" />
                        ) : (
                          <i className="fa fa-money" />
                        )}
                      </Button>
                    </>
                  )}
                </td>
                <td className="quantity">
                  <Button
                    small
                    onClick={() => this.oneLessProduct(index)}
                    disabled={isReadOnly}
                  >
                    <i className="fa fa-minus" />
                  </Button>
                  <input
                    value={item.quantity}
                    onChange={(e) => {
                      if (
                        item.product.decimal_stock ===
                        Constants.DECIMAL_STOCK.NO
                      ) {
                        if (
                          Globals.validateInteger(e.target.value) ||
                          e.target.value === ""
                        ) {
                          if (Number(e.target.value) > item.product.stock)
                            return;
                          this.changeManual(index, e.target.value);
                        }
                      } else {
                        if (Number(e.target.value) > item.product.stock) return;
                        this.changeManual(index, e.target.value);
                      }
                    }}
                    onBlur={(e) => {
                      if (e.target.value === "") this.changeManual(index, "0");
                    }}
                    disabled={isReadOnly}
                  />
                  <Button
                    small
                    onClick={() => this.oneMoreProduct(index)}
                    disabled={isReadOnly}
                  >
                    <i className="fa fa-plus" />
                  </Button>
                </td>
                <td align="right">
                  <span>Bs. {Globals.formatMiles(item.baseAfterIndiv_bs)}</span>
                  {!item.isPermanent && (
                    <img
                      src={CloseIcon}
                      className="btn-remove"
                      title="Remover producto"
                      alt="Remover producto"
                      onClick={() => this.removeProduct(index)}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="modal-bottom" style={{width: "98%"}}>
          <div>
            <div className="table-footer">
              <div className="date">
                <label>Fecha</label>
                <span>{form.date}</span>
              </div>
              <div className="reason">
                <label>Motivo de nota de débito</label>
                <input
                  value={form.comments}
                  onChange={(v) => this.change(v.target.value, "comments")}
                  disabled={isReadOnly}
                />
              </div>
            </div>

            <div className="table-footer">
              <div>
                <label>Número de Factura</label>
                <input
                  value={form.bill_number}
                  onChange={(v) => this.change(v.target.value, "bill_number")}
                  disabled={isReadOnly}
                />
              </div>
              <div className="reason">
                <label>Método de pago</label>
                <Select
                  className="filter"
                  value={form.payment_method_id}
                  options={this.state.methods.map((m) => ({
                    value: m.id,
                    label: m.name,
                  }))}
                  onChange={(e) =>
                    this.change(e.target.value, "payment_method_id")
                  }
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </div>

          <div className="totals">
            <div>
              <span>Sub-total</span>
              <span>
                Bs. {Globals.formatMiles(totals?.subtotal_without_disc_bs || 0)}
              </span>
            </div>
            <div>
              <span>% Desc</span>
              <span>
                <span>
                  ({Globals.formatMiles(debitedItem?.discount_percentage)}
                  %){" "}
                </span>
                <span>
                  -Bs. {Globals.formatMiles(totals?.discount_bs || 0)}
                </span>
              </span>
            </div>
            {totals.iva_16_bs > 0 && (
              <div>
                <span>IVA ({Constants.TAXES.IVA}%)</span>
                <span>Bs. {Globals.formatMiles(totals.iva_16_bs)}</span>
              </div>
            )}
            {totals.iva_8_bs > 0 && (
              <div>
                <span>IVA ({Constants.TAXES.IVA_8}%)</span>
                <span>Bs. {Globals.formatMiles(totals.iva_8_bs)}</span>
              </div>
            )}
            {totals.iva_31_bs > 0 && (
              <div>
                <span>IVA ({Constants.TAXES.IVA_31}%)</span>
                <span>Bs. {Globals.formatMiles(totals.iva_31_bs)}</span>
              </div>
            )}
            {totals?.igtf_total_bs > 0 && (
              <div>
                <span>IGTF</span>
                <span>
                  Bs. {Globals.formatMiles(totals?.igtf_total_bs || 0)}
                </span>
              </div>
            )}
            <div>
              <span>Total</span>
              <span>Bs. {Globals.formatMiles(totals?.total_bs || 0)}</span>
            </div>
          </div>
        </div>

        <span className="increase-label">Aumento Total</span>
        <div className="increase-total">
          <span>Bs.</span>
          <input
            readOnly
            value={Globals.formatMiles(
              isReadOnly ? this.convert(debitedItem.total) : totals.diff_bs,
            )}
          />
          <span>$</span>
          <input
            readOnly
            value={Globals.formatMiles(
              isReadOnly ? debitedItem.total : totals.diff_usd,
            )}
          />
        </div>

        {!isReadOnly && (
          <div className="modal-actions">
            <button onClick={() => this.props.onClose()}>Cancelar</button>
            <button onClick={this.submit}>Procesar</button>
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => ({
  user: state.user,
}))(ModalCreateDebit);
